import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Work = () => {
    // Default active is the first one
    const [activeId, setActiveId] = useState(1);

    // ONLY SHOW YOUR TOP 4 BEST PROJECTS HERE
    const projects = [
        {
            id: 1,
            title: "GYM.OS",
            subtitle: "TRAINER SAAS",
            desc: "The operating system for modern fitness. Stripe payments, scheduling, and diet planning in one core.",
            tech: "MERN • REDUX",
            image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=1470&auto=format&fit=crop"
        },
        {
            id: 2,
            title: "NEBULA",
            subtitle: "ECOMMERCE",
            desc: "Headless architecture. 0.1s load times. Built for high-volume fashion retail.",
            tech: "NEXT.JS • SHOPIFY",
            image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?q=80&w=1470&auto=format&fit=crop"
        },
        {
            id: 3,
            title: "VELOCITY",
            subtitle: "MOBILE APP",
            desc: "Cross-platform logistics tracking. Real-time GPS and driver management.",
            tech: "REACT NATIVE",
            image: "https://images.unsplash.com/photo-1566241440091-ec10de8db2e1?q=80&w=2516&auto=format&fit=crop"
        },
        {
            id: 4,
            title: "CRYPTO",
            subtitle: "WEB3 DASH",
            desc: "Decentralized asset visualization with real-time WebSocket data streams.",
            tech: "REACT • ETHERS",
            image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=2664&auto=format&fit=crop"
        }
    ];

    return (
        <section className="bg-void py-32 min-h-screen flex flex-col justify-center overflow-hidden">

            <div className="container mx-auto px-4">

                {/* --- HEADER --- */}
                <div className="mb-12 flex items-center gap-4">
                    <div className="h-px bg-white/20 flex-1"></div>
                    <h2 className="text-sm font-mono text-neon-blue tracking-[0.5em] uppercase">
                        Mission Log // Top 4
                    </h2>
                    <div className="h-px bg-white/20 flex-1"></div>
                </div>

                {/* --- THE EXPANSION DECK (Top 4) --- */}
                <div className="flex flex-col md:flex-row h-[600px] gap-4 mb-16">

                    {projects.map((project) => (
                        <div
                            key={project.id}
                            onMouseEnter={() => setActiveId(project.id)}
                            className={`relative rounded-3xl overflow-hidden cursor-pointer transition-[flex] duration-700 ease-out-expo ${activeId === project.id
                                    ? 'flex-[10] shadow-[0_0_50px_rgba(0,0,0,0.5)] border border-white/20'
                                    : 'flex-[1] grayscale brightness-50 border border-transparent hover:border-white/10'
                                }`}
                        >
                            {/* Background Image */}
                            <img
                                src={project.image}
                                alt={project.title}
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 transform hover:scale-110"
                            />

                            {/* Gradient Overlay */}
                            <div className={`absolute inset-0 bg-gradient-to-t from-void via-void/50 to-transparent transition-opacity duration-500 ${activeId === project.id ? 'opacity-90' : 'opacity-60'}`} />

                            {/* Content */}
                            <div className="absolute inset-0 p-8 md:p-12 flex flex-col justify-end">

                                {/* Collapsed Vertical Text */}
                                {activeId !== project.id && (
                                    <div className="hidden md:flex absolute inset-0 items-center justify-center">
                                        <h3 className="text-2xl font-black text-white/50 -rotate-90 whitespace-nowrap tracking-widest uppercase">
                                            {project.title}
                                        </h3>
                                    </div>
                                )}

                                {/* Expanded Details */}
                                <div className={`transition-all duration-500 delay-100 ${activeId === project.id
                                        ? 'opacity-100 translate-y-0'
                                        : 'opacity-0 translate-y-8 absolute bottom-8'
                                    }`}>

                                    <div className="inline-block px-3 py-1 mb-4 border border-neon-blue/30 bg-neon-blue/10 rounded-full">
                                        <span className="text-xs font-mono text-neon-blue font-bold tracking-widest">
                                            {project.tech}
                                        </span>
                                    </div>

                                    <h3 className="text-4xl md:text-7xl font-black text-white font-display mb-2 uppercase leading-none">
                                        {project.title}
                                    </h3>
                                    <p className="text-xl md:text-2xl text-gray-300 font-light mb-6">
                                        {project.subtitle}
                                    </p>

                                    <div className="overflow-hidden transition-all duration-500 delay-200 max-w-lg hidden md:block">
                                        <p className="text-gray-400 leading-relaxed mb-6">
                                            {project.desc}
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* --- FOOTER: VIEW ALL BUTTON --- */}
                <div className="flex justify-center">
                    <a
                        href="/projects" // Link this to your separate "All Projects" page
                        className="group relative px-12 py-6 bg-surface border border-white/10 rounded-full overflow-hidden hover:border-neon-blue/50 transition-all duration-300"
                    >
                        {/* Hover Fill Effect */}
                        <div className="absolute inset-0 bg-neon-blue/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />

                        <div className="relative flex items-center gap-4">
                            <Link to={"/contact"}>
                                <span className="text-sm font-mono font-bold text-white tracking-widest uppercase group-hover:text-neon-blue transition-colors">
                                    View Full Project Archive
                                </span>
                            </Link>
                            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-white/10 text-white group-hover:bg-neon-blue group-hover:text-black transition-all">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                                </svg>
                            </span>
                        </div>
                    </a>
                </div>

            </div>
        </section>
    );
};

export default Work;